/*
 * @Author       : Bruce
 * @Date         : 2025-09-25 14:51:28
 * @LastEditors  : Bruce
 * @LastEditTime : 2025-09-26 10:24:43
 * @FilePath     : /src/utils/password.ts
 * @Description  :
 * Copyright 2025 Bruce, All Rights Reserved.
 * 2025-09-25 14:51:28
 */
/**
 * @Author       : Bruce
 * @Date         : 2025-09-17
 * @LastEditors  : Bruce
 * @LastEditTime : 2025-09-17 14:25:00
 * @FilePath     : /src/utils/passwordStrength.ts
 * @Description  : 密码强度计算工具
 * Copyright 2025 Bruce, All Rights Reserved.
 */

/**
 * 计算密码强度
 * @param password 待检测的密码字符串
 * @returns 密码强度等级 (0: 无密码, 1: 弱, 2: 中等, 3: 强)
 */
export function checkPasswordLevel(password: string): number {
    if (!password) {
        return 0
    }

    let score = 0

    // 长度检查
    if (password.length >= 6) score += 20
    if (password.length >= 8) score += 15
    if (password.length >= 12) score += 10

    // 字符类型检查
    if (/[a-z]/.test(password)) score += 15 // 小写字母
    if (/[A-Z]/.test(password)) score += 15 // 大写字母
    if (/[0-9]/.test(password)) score += 15 // 数字
    if (/[^A-Za-z0-9]/.test(password)) score += 20 // 特殊字符

    // 根据分数确定强度等级
    if (score < 30) {
        return 1 // 弱
    } else if (score < 70) {
        return 2 // 中等
    } else {
        return 3 // 强
    }
}

/**
 * 检查密码长度是否有效 (3-16位)
 * @param password 待检测的密码字符串
 * @returns 是否满足长度要求
 */
export function isPasswordLengthValid(password: string): boolean {
    if (!password) return false
    const length = password.length
    return length >= 3 && length <= 16
}

/**
 * 计算密码安全等级 (新规则)
 * @param password 待检测的密码字符串
 * @returns 安全等级 (0: 无密码, 1-4: 每满足一个条件提升一级)
 */
export function checkPasswordSecurity(password: string): number {
    if (!password) {
        return 0
    }

    let level = 0

    // 每满足一个条件提升一级安全
    if (/[0-9]/.test(password)) level++ //  数字
    if (/[a-z]/.test(password)) level++ //  小写字母
    if (/[A-Z]/.test(password)) level++ //  大写字母
    if (/[^A-Za-z0-9]/.test(password)) level++ // 符号

    return Math.min(level, 3) // 最高3级 (对应强度指示器的3个段)
}
